module.exports = __webpack_public_path__ + "static/img/1362_phase_function_Paper_PointsHejduk_Prediction.be4bfc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1362_phase_function_Paper_PointsHejduk_Prediction.png
// module id = D4MI
// module chunks = 0